/** Team records and signup origin do not establish a connected AI agent. */
export function connectedAgentLabel(count: number | null | undefined): string {
  if (count == null) return 'Unknown';
  return count > 0 ? `Authorized (${count})` : 'Not connected';
}
export function signupOriginLabel(origin: string | null | undefined): string {
  if (origin === undefined) return 'Not available';
  if (origin === 'app') return 'App';
  if (origin === 'mcp') return 'MCP';
  if (origin === 'test' || origin === 'internal') return `Recorded: ${origin}`;
  return origin ? `Recorded: ${origin}` : 'Not recorded';
}
